import { GeoPoint } from './geo-point';
var City = /** @class */ (function () {
    function City(inputData) {
        var data = inputData || {};
        this.cityPlaceId = data['cityPlaceId'];
        this.address = data['address'];
        this.city = data['city'];
        this.zipCode = data['zipCode'];
        this.department = data['department'];
        this.departmentShort = data['departmentShort'];
        this.state = data['state'];
        this.stateShort = data['stateShort'];
        this.country = data['country'];
        this.countryShort = data['countryShort'];
        this.geo = new GeoPoint(data['geo']);
        this.type = data['type'];
    }
    Object.defineProperty(City.prototype, "short", {
        /**
         * Print city. Format is one of these, depending on the available data :
         * - address, city
         * - city, department
         * - city, country
         * - city
         * - department, country
         * - department
         * - country
         */
        get: function () {
            var _this = this;
            if (this.address) {
                return this.mergeParts([this.address, this.city]);
            }
            if (this.city) {
                var nonHomonymHigherOrderArea = [this.department, this.country]
                    .filter(Boolean)
                    .find(function (area) { return area !== _this.city; });
                return this.mergeParts([this.city, nonHomonymHigherOrderArea]);
            }
            if (this.department) {
                return this.mergeParts([this.department, this.country]);
            }
            return this.country;
        },
        enumerable: false,
        configurable: true
    });
    City.prototype.mergeParts = function (parts) {
        return parts.filter(Boolean).join(', ');
    };
    return City;
}());
export { City };
